import { createPrefetchableAsyncPaginatedDataContext, pageDataErrorHandler } from '#src/app/shared/contexts/asyncData';

import { getFirstPageData, getNextPageData } from './api';

/** @knip-ignore */
export const {
	Context: LocalPagePaginatedPetitionUpdatesDataContext,
	Provider: LocalPagePaginatedPetitionUpdatesDataContextProvider,
	useContext: useLocalPagePaginatedPetitionUpdatesData,
	useAsyncData: useLocalPagePaginatedPetitionUpdatesDataFromApi,
	prefetchAsyncData: prefetchLocalPagePaginatedPetitionUpdatesDataFromApi,
} = createPrefetchableAsyncPaginatedDataContext({
	name: 'LocalPagePaginatedPetitionUpdatesDataContext',
	dataProperty: 'petitionUpdatesPaginatedData',
	getFirstPageData,
	getNextPageData,
	getUniqueId: (slug) => slug,
	hookDeps: (slug) => [slug],
	errorHandler: pageDataErrorHandler(),
});
